import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: true,
  hasErrors: false,
  contactData: [],
  pageTitle: "",
};
const feedPath = FEEDS.CONTACT_US;
const feedPathResponse = FEEDS.CONTACT_US_RESPONSE;

const contactSlice = createSlice({
  name: "contactData",
  initialState,
  reducers: {
    getContact: (state) => {
      state.loading = true;
    },
    getContactSuccess: (state, { payload }) => {
      state.contactData = payload;
      state.loading = false;
      state.hasErrors = false;
      state.pageTitle = payload.data.pageData.pageTitle;
    },
    getContactFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const { getContact, getContactSuccess, getContactFailure } =
  contactSlice.actions;

// A selector
export const contactSelector = (state) => state.contactData;

export default contactSlice.reducer;

export function fetchContact() {
  return async (dispatch) => {
    dispatch(getContact());
    try {
      const response = await fetch(feedPath);
      const data = await response.json();
      dispatch(getContactSuccess(data));
    } catch (error) {
      dispatch(getContactFailure());
    }
  };
}

export const postForm = async (destEmail, subject, country, category, comment, email) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ destEmail, subject, country, category, comment, email }),
  };
  let result = await fetch(feedPathResponse, requestOptions)
    .then((response) => response.json())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
  return result;
};
